export default __webpack_public_path__ + "static/media/ugcall.b53f8b89.PNG";